import { Heading, Stack } from '@customerio/pluma-components/react';
import { CheckList } from './check-list';

const BALANCE_COVERS = [
  'Email sending starts again',
  'Stopped automations pick back up',
  'Active profiles beyond the free 500',
  'Unused credits roll over',
];

const CREDITS_COVER = [
  'Email, SMS, and webhook sending',
  'Active profiles beyond the free 500',
  'Stored profiles and objects past the free 1,000',
  'Top up any time',
  'No monthly fee, no contract',
];

type AddFundsBenefitsProps = {
  isFirstPurchase: boolean;
};

export function AddFundsBenefits({ isFirstPurchase }: AddFundsBenefitsProps) {
  const items = isFirstPurchase ? CREDITS_COVER : BALANCE_COVERS;

  return (
    <Stack gap="150" data-test-add-funds-benefits>
      <Heading level="3" size="sm">
        {isFirstPurchase ? 'What credits cover' : 'Your balance covers'}
      </Heading>
      <CheckList items={items} />
    </Stack>
  );
}
